var _rect, _rect2, _path, _path2, _path3, _rect3, _path4, _path5, _path6, _path7, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPasswordManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 89,
    viewBox: "0 0 102 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26,
    width: 91,
    height: 53,
    rx: 8,
    fill: "#B0D2EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 91,
    height: 53,
    rx: 8,
    fill: "#D6E8F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 23C26 19.134 29.134 16 33 16H57C60.866 16 64 19.134 64 23V41C64 44.866 60.866 48 57 48H33C29.134 48 26 44.866 26 41V23Z",
    fill: "#3F936A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 0C39.701 0 35 4.70101 35 10.5V16H39V10.5C39 6.91015 41.9101 4 45.5 4C49.0899 4 52 6.91015 52 10.5V16H56V10.5C56 4.70101 51.299 0 45.5 0Z",
    fill: "#4B81AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 32.6632C48.1825 32.1015 49 30.8962 49 29.5C49 27.567 47.433 26 45.5 26C43.567 26 42 27.567 42 29.5C42 30.8962 42.8175 32.1015 44 32.6632V37.5C44 38.3284 44.6716 39 45.5 39C46.3284 39 47 38.3284 47 37.5V32.6632Z",
    fill: "#2A5B43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 69,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2874B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4998 65.3301C14.0215 65.0539 13.8576 64.4423 14.1338 63.964L15.2678 61.9999H13C12.4477 61.9999 12 61.5522 12 60.9999C12 60.4476 12.4477 59.9999 13 59.9999H15.2677L14.1338 58.0359C13.8576 57.5576 14.0215 56.946 14.4998 56.6699C14.9781 56.3938 15.5897 56.5576 15.8658 57.0359L16.9998 59L18.1338 57.0359C18.4099 56.5576 19.0215 56.3937 19.4998 56.6698C19.9781 56.946 20.142 57.5576 19.8658 58.0359L18.7319 59.9999H21C21.5523 59.9999 22 60.4476 22 60.9999C22 61.5522 21.5523 61.9999 21 61.9999H18.7318L19.8658 63.9641C20.142 64.4424 19.9781 65.054 19.4998 65.3301C19.0215 65.6063 18.4099 65.4424 18.1338 64.9641L16.9998 63L15.8658 64.964C15.5897 65.4423 14.9781 65.6062 14.4998 65.3301Z",
    fill: "#093E62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4998 65.3301C33.0215 65.0539 32.8576 64.4423 33.1338 63.964L34.2678 61.9999H32C31.4477 61.9999 31 61.5522 31 60.9999C31 60.4476 31.4477 59.9999 32 59.9999H34.2677L33.1338 58.0359C32.8576 57.5576 33.0215 56.946 33.4998 56.6699C33.9781 56.3938 34.5897 56.5576 34.8658 57.0359L35.9998 59L37.1338 57.0359C37.4099 56.5576 38.0215 56.3937 38.4998 56.6698C38.9781 56.946 39.142 57.5576 38.8658 58.0359L37.7319 59.9999H40C40.5523 59.9999 41 60.4476 41 60.9999C41 61.5522 40.5523 61.9999 40 61.9999H37.7318L38.8658 63.9641C39.142 64.4424 38.9781 65.054 38.4998 65.3301C38.0215 65.6063 37.4099 65.4424 37.1338 64.9641L35.9998 63L34.8658 64.964C34.5897 65.4423 33.9781 65.6062 33.4998 65.3301Z",
    fill: "#093E62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4998 65.3301C52.0215 65.0539 51.8576 64.4423 52.1338 63.964L53.2678 61.9999H51C50.4477 61.9999 50 61.5522 50 60.9999C50 60.4476 50.4477 59.9999 51 59.9999H53.2677L52.1338 58.0359C51.8576 57.5576 52.0215 56.946 52.4998 56.6699C52.9781 56.3938 53.5897 56.5576 53.8658 57.0359L54.9998 59L56.1338 57.0359C56.4099 56.5576 57.0215 56.3937 57.4998 56.6698C57.9781 56.946 58.142 57.5576 57.8658 58.0359L56.7319 59.9999H59C59.5523 59.9999 60 60.4476 60 60.9999C60 61.5522 59.5523 61.9999 59 61.9999H56.7318L57.8658 63.9641C58.142 64.4424 57.9781 65.054 57.4998 65.3301C57.0215 65.6063 56.4099 65.4424 56.1338 64.9641L54.9998 63L53.8658 64.964C53.5897 65.4423 52.9781 65.6062 52.4998 65.3301Z",
    fill: "#093E62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4998 65.3301C71.0215 65.0539 70.8576 64.4423 71.1338 63.964L72.2678 61.9999H70C69.4477 61.9999 69 61.5522 69 60.9999C69 60.4476 69.4477 59.9999 70 59.9999H72.2677L71.1338 58.0359C70.8576 57.5576 71.0215 56.946 71.4998 56.6699C71.9781 56.3938 72.5897 56.5576 72.8658 57.0359L73.9998 59L75.1338 57.0359C75.4099 56.5576 76.0215 56.3937 76.4998 56.6698C76.9781 56.946 77.142 57.5576 76.8658 58.0359L75.7319 59.9999H78C78.5523 59.9999 79 60.4476 79 60.9999C79 61.5522 78.5523 61.9999 78 61.9999H75.7318L76.8658 63.9641C77.142 64.4424 76.9781 65.054 76.4998 65.3301C76.0215 65.6063 75.4099 65.4424 75.1338 64.9641L73.9998 63L72.8658 64.964C72.5897 65.4423 71.9781 65.6062 71.4998 65.3301Z",
    fill: "#093E62"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 69,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2874B1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 69,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2874B1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 69,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2874B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPasswordManager);
export default __webpack_public_path__ + "static/media/imgPasswordManager.c67f7f5eb7b651389bfbed4493adcf23.svg";
export { ForwardRef as ReactComponent };